import { parseISO } from 'date-fns';

/**
 * Interpreta un `LocalDateTime` esposto dal backend come **UTC** (D-48).
 *
 * Il BE scrive questi timestamp con `LocalDateTime.now()` su un ambiente a `TZ` UTC: la
 * stringa non porta `Z`/offset. `parseISO` di date-fns, senza designatore di fuso,
 * interpreta il valore come **ora locale del device**: su un device `Europe/Rome` questo
 * mostra l'orario invariato invece di aggiungere lo scarto UTC→locale (-2h in CEST, -1h in
 * CET rispetto all'atteso). Si forza l'interpretazione UTC aggiungendo `Z` se assente, poi
 * si lascia che `format` la converta nel fuso del device: stesso meccanismo, in entrambi i
 * sensi, di qualunque offset stagionale (nessuna sottrazione fissa).
 *
 * Introdotta con `pratica-allegati-list.component.ts` (D-48, allegati); riusata nel
 * Riepilogo della pratica per lo stesso campo di tipo `LocalDateTime` (`timestamp_richiesta`).
 */
export function parseBackendLocalDateTime(value: string): Date {
  const hasTimezone = /[zZ]|[+-]\d{2}:?\d{2}$/.test(value);
  return parseISO(hasTimezone ? value : `${value}Z`);
}
